import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from '@/App'
import { applyTheme } from '@/design'

const container = document.getElementById('root')
if (!container) throw new Error('no #root element')

// The default theme is in place before the first paint; the shell swaps in the
// tenant's accent once branding has loaded.
applyTheme(document.documentElement)

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
